'use strict';

angular.module('itPurchasingControllers')

.controller('ItPurchasingController', ['$scope', '$state', '$stateParams', '$translate', 'topBar', 'ITPurchasingService', function ($scope, $state, $stateParams, $translate, topBar, ITPurchasingService) {

    $translate('iam.itPurchasing.pageTitle').then(function(translation) {
        topBar.setTitleAndIcon(translation, 'fa-usd');
    });

    $scope.ctxtFilter = {};
    $scope.ctxtFilter.withMyRequests = false;

    $scope.filterStatus = {};
    $scope.filterStatus.name = $stateParams.searchTerm ? null : 'To Authorize';

    $scope.keywordsSearch = $stateParams.searchTerm || null;
    $scope.selectedCard = null;

    $scope.view = {};
    $scope.view.orderingBy = 'DateReverse';

    // Show multiple select toggle
    $scope.showMultipleSelectToggle = function (systemAndEmployee) {
        if ($scope.view.isMultiSelect) { return false; }

        if (!$scope.systemsAndEmployees || !$scope.systemsAndEmployees.length) { return false;}

        return _.every($scope.systemsAndEmployees, { CanBeAuthorized: true });
    };

    // Toggle multi selection
    $scope.toggleMultiSelection = function () {
        $scope.view.isMultiSelect   = !$scope.view.isMultiSelect;
        $scope.view.acceptOverwrite = false;

        if ($scope.view.isMultiSelect) { $scope.unselectAllSystems(); }
    };

    // Select all systems
    $scope.selectAllSystems = function () {
        $scope.systemsAndEmployees = _.map($scope.systemsAndEmployees, function (systemAndEmployee) {
            systemAndEmployee.isSelectedForMultiSelect = true;

            return systemAndEmployee;
        });
    };

    // Unselect all systems
    $scope.unselectAllSystems = function () {
        $scope.systemsAndEmployees = _.map($scope.systemsAndEmployees, function (systemAndEmployee) {
            systemAndEmployee.isSelectedForMultiSelect = false;

            return systemAndEmployee;
        });
    };

    // Are some systems selected
    $scope.areSomeSystemsSelected = function () {
        return _.some($scope.systemsAndEmployees, { isSelectedForMultiSelect: true });
    };


    // Show load more cards
    $scope.showLoadMoreCards = function () {

        if (_.isUndefined($scope.systemsAndEmployees) || $scope.systemsAndEmployees.length === 0) {
            return false;
        }

        if (!$scope.filterStatus.name) {
            return $scope.systemsAndEmployees.length < _.reduce($scope.nbCards, function (total, nbCardsPerStatus) {
                return total + nbCardsPerStatus;
            }, 0);
        }

        if ($scope.filterStatus.name === 'To Assign') {
            return $scope.systemsAndEmployees.length < $scope.nbCards.NbToAssign;
        }

        if ($scope.filterStatus.name === 'To Authorize') {
            return $scope.systemsAndEmployees.length < $scope.nbCards.NbToAuthorize;
        }

        if ($scope.filterStatus.name === 'Custodian Processing') {
            return $scope.systemsAndEmployees.length < $scope.nbCards.NbToCustodianProcessing;
        } 
            
        return false;
    };

    // Load more cards
    $scope.loadMoreCards = function () {
        if (!_.isUndefined($scope.systemsAndEmployees)) {
            $scope.afterUserAccessRequestID = $scope.systemsAndEmployees[$scope.systemsAndEmployees.length - 1].UserAccessRequestID;
        }

        ITPurchasingService
            .getAllSystemEmployeeWithSignificantCost($scope.keywordsSearch, $scope.filterStatus.name,
                                                     $scope.afterUserAccessRequestID, $scope.ctxtFilter.withMyRequests)
            .then(function (systemsAndEmployees) {
                $scope.nbCards = systemsAndEmployees.NbCards;
                $scope.systemsAndEmployees = _.union($scope.systemsAndEmployees, systemsAndEmployees.SystemsAndEmployees);

                for (var attrname in systemsAndEmployees.PendingSystemRoles) {
                    $scope.pendingSystemRoles[attrname] = systemsAndEmployees.PendingSystemRoles[attrname];
                }

                for (var attrname in systemsAndEmployees.BusinessTasks) {
                    $scope.businessTasks[attrname] = systemsAndEmployees.BusinessTasks[attrname];
                }
            });
    }

    // Select card
    $scope.selectCard = function (systemAndEmployee) {
        $scope.selectedCard = systemAndEmployee;
        ITPurchasingService
           .getExistingSystemRoles(systemAndEmployee)
           .then(function (newContainer) {
               for (var bySystem in newContainer.PendingSystemRoles) {
                   var pendings = $scope.pendingSystemRoles[bySystem];

                   $scope.existingSysRoles = _.filter(newContainer.PendingSystemRoles[bySystem], function (existingSysRole) {
                       var exist = _.find(pendings, function (p) { return p.SystemRoleID === existingSysRole.SystemRoleID; });
                       return exist.length == 0;
                   });
               }
           });
    }

    // Is Selected card
    $scope.isSelectedCard = function (systemAndEmployee) {
        return $scope.selectedCard === systemAndEmployee;
    };

    // Is completed card
    $scope.isCompletedCard = function (systemAndEmployee) {
        return systemAndEmployee.RequestStatus.toLowerCase() === 'completed';
    }

    // Order by System
    $scope.orderBySystem = function (isReverse) {
        $scope.view.orderingBy = 'System';
        $scope.systemsAndEmployees = _.sortBy($scope.systemsAndEmployees, 'SystemName');

        if (isReverse) {
            $scope.view.orderingBy = 'SystemReverse';
            $scope.systemsAndEmployees = _.chain($scope.systemsAndEmployees)
                                          .reverse()
                                          .value();
        }
    };

    // Order by Employee
    $scope.orderByEmployee = function (isReverse) {
        $scope.view.orderingBy = 'Employee';
        $scope.systemsAndEmployees = _.sortBy($scope.systemsAndEmployees, 'EmployeeFirstName');

        if (isReverse) {
            $scope.view.orderingBy = 'EmployeeReverse';
            $scope.systemsAndEmployees = _.chain($scope.systemsAndEmployees)
                                          .reverse()
                                          .value();
        }
    };

    // Order by Date
    $scope.orderByDate = function (isReverse) {
        $scope.view.orderingBy     = 'Date';
        $scope.systemsAndEmployees = _.sortBy($scope.systemsAndEmployees, 'UpdatedTimestamp');
           
        if (isReverse) {
            $scope.view.orderingBy = 'DateReverse';
            $scope.systemsAndEmployees = _.chain($scope.systemsAndEmployees)
                                          .reverse()
                                          .value();
        }
    };

    // Search systems employees
    $scope.searchSystemsEmployees = function () {
        ITPurchasingService
            .getAllSystemEmployeeWithSignificantCost($scope.keywordsSearch, $scope.filterStatus.name,
                                                     null, $scope.ctxtFilter.withMyRequests)
            .then(function (systemsAndEmployees) {
                $scope.nbCards = systemsAndEmployees.NbCards;
                $scope.systemsAndEmployees = systemsAndEmployees.SystemsAndEmployees;
                $scope.pendingSystemRoles = systemsAndEmployees.PendingSystemRoles;
                $scope.businessTasks = systemsAndEmployees.BusinessTasks;

                $scope.selectedCard = null;
            });
    };

    $scope.searchSystemsEmployees();
}]);

